module.exports = __webpack_public_path__ + "img/pannelOneIcon.39b739f7.png";